
(function () {
    angular.module('tmx-app').factory('LoanProductService', ['$q','$mdMedia', 'tmxResource', 'cacheStore', 'lookupService', 'TMX_FINANCE_CONSTANTS',
        function ($q, $mdMedia,tmxResource, cacheStore, lookupService, TMX_FINANCE_CONSTANTS) {

            var LoanProducts = tmxResource("Product");
            LoanProducts.recievedProductTypes = false;
            LoanProducts.recievedFreq = false;
            LoanProducts.lookup = {};
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


            LoanProducts.productTypes = lookupService.getLocalLookupsByType(lkupType.Product);
            LoanProducts.ProductClassifications = lookupService.getLocalLookupsByType(lkupType.PRODUCT_CLASSIFICATION);


            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////************************FUNCTIONS**********************************************/////////////////////
            ///////////////////////////////GET ALL ROLES: LIST RESOLVE
            LoanProducts.getAllLoanProducts = function () {
                var deferred = $q.defer();
                var productList = cacheStore.get("Product/list");
                if (productList) {
                    deferred.resolve(productList);
                    return deferred.promise;
                }
                else {
                    tmxResource("Product/list").all().then(function (response) {
                        if (response) {
                            cacheStore.set('Product/list', response);
                            deferred.resolve(response);
                        }
                        else {
                            deferred.reject('Unable to get product list');
                        }
                    });
                    return deferred.promise;
                }
            };

            LoanProducts.getAllActiveProducts = function () {
                return tmxResource("Product").getByAction("ActiveLov", true, 'get');
            };

            LoanProducts.getActiveProducts = function () {
                return LoanProducts.getByAction("GetAllActiveProducts", true, 'get');
            };

            LoanProducts.getProductsbyType = function (type) {
                return tmxResource("Product").getByAction("GetProductsbyType/" + type, true, 'get');
            };
            LoanProducts.getStatesbyProduct = function (productId) {
                return tmxResource("LoanApplication").getByAction("WorkflowStates/" + productId, true, 'get');
            };
            LoanProducts.getRulesbyProduct = function (productId, workflowstate) {
                return tmxResource("ProductRule").getByAction("GetproductRuleByState/" + productId + "/" + workflowstate, true, 'get');
            };
            LoanProducts.getRulebyRuleId = function (ruleId) {
                return tmxResource("ProductRule").getByAction("GetRule/" + ruleId, true, 'get');
            };
            LoanProducts.updateRule = function (obj) {
                return tmxResource("ProductRule").getByAction("UpdateRule", true, 'post', obj);
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // lookupService.getProductTypes().then(function (ProductTypes){
            //     LoanProducts.lookup.types = ProductTypes; //pushing data into local array
            //     LoanProducts.receivedProductTypes = true;
            //     LoanProducts.gridColumn[2].data = LoanProducts.lookup.types;
            //     LoanProducts.filterColumn[2].data = LoanProducts.lookup.types;

            // });

            // lookupService. getLoanRepaymentFreq().then(function (repaymentFreq){

            //     LoanProducts.lookup.repaymentFreq = repaymentFreq; //pushing data into local array
            //     LoanProducts.recievedFreq = true;
            //     LoanProducts.gridColumn[3].data = LoanProducts.lookup.repaymentFreq;
            //     LoanProducts.filterColumn[3].data = LoanProducts.lookup.repaymentFreq;

            // });
            //////////////////////////////////////KENDO GRID COLUMNS///////////////////////////////////////////////////
            LoanProducts.status = [
                {
                    HiddenValue: "active",
                    VisibleValue: "Active"
                },
                {
                    HiddenValue: "inactive",
                    VisibleValue: "Inactive"
                }];

            LoanProducts.gridColumn = [

                {
                    field: "ProductName",
                    title: "Name",
                    type: "string",                    
                    template: "<md-button class='tmx-primary-text-grid' ng-disabled=\"!LoanProductCtrl.editPermission\" ng-click='LoanProductCtrl.clickView(dataItem)'  ng-bind='dataItem.ProductName'></md-button><div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}}>{{dataItem.Status}} </span> <span class='subtitle'>{{dataItem.ProductDescription}}</span></div>",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LoanProductCtrl.isFiltered('ProductName')}\" >{{'Name' | translate}}<i class='fa fa-filter' ng-if='LoanProductCtrl.isFiltered(\"ProductName\")' ></i></span>"


                },
                {
                    field: "ProductCode",
                    title: "Code",
                    type: "string",                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LoanProductCtrl.isFiltered('ProductCode')}\" >{{'Code' | translate}}<i class='fa fa-filter' ng-if='LoanProductCtrl.isFiltered(\"ProductCode\")' ></i></span>"

                },
                {
                    field: "ProductType",
                    title: "Type",
                    type: "text",                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LoanProductCtrl.isFiltered('ProductType')}\" >{{'Type' | translate}}<i class='fa fa-filter' ng-if='LoanProductCtrl.isFiltered(\"ProductType\")' ></i></span>"

                },               
                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    data: LoanProducts.status,
                    hidden:true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LoanProductCtrl.isFiltered('EffectiveEndDate')}\" >{{'Status' | translate}} <i class='fa fa-filter' ng-if='LoanProductCtrl.isFiltered(\"EffectiveEndDate\")' ></i></span>"

                },
                {
                    field: "",
                }
            ];
            LoanProducts.columns = angular.copy(LoanProducts.gridColumn);
            LoanProducts.filterColumn = [

                {
                    field: "ProductName",
                    title: "Name",
                    type: "string",
                    search: true,

                },
                {
                    field: "ProductCode",
                    title: "Code",
                    type: "number",
                    search: true,
                },
                {
                    field: "ProductTypeLkp",
                    title: "Type",
                    type: "select",
                    isNumber: true,
                    search: true,
                    data: LoanProducts.lookup.types
                },
                // {
                //     field:"RepaymentFrequencyLkp",
                //     title:"RepaymentFrequency",
                //     type:"select",
                //     isNumber: true,
                //     data: LoanProducts.lookup.repaymentFreq
                // },
                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    search: true,
                    data: LoanProducts.status
                }
            ];
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            return LoanProducts;

        }]);
})();